import React from 'react'

import * as routes from '../../constants/routes'
import { NotFoundContainer, NotFoundHeadline, BackToLandingLink } from '../StyledComponents/NotFoundPage'

const NotFound = () => (
    <NotFoundContainer>
        <NotFoundHeadline>This page doesn‘t exist!</NotFoundHeadline>
        <BackToLandingLink to={routes.LANDING}>Back to Landing Page</BackToLandingLink>
    </NotFoundContainer>
)
export default NotFound



// WEBPACK FOOTER //
// ./src/components/pages/NotFound.js